import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from '../../components/menu/header';
import Footer from '../../components/menu/footer';
import NavSezione from './NavSezione';
// I token della sezione vanno caricati prima di ogni foglio che li usa.
import '../../components/statistiche/tokens.css';
import './StatisticheLayout.css';

/**
 * La cornice comune a tutta la sezione. Esiste perché header, footer e contenitore non si
 * ripetano in nove pagine, e perché la navigazione fra i tre indici stia in un posto solo
 * invece di essere ricostruita da ogni pagina come una scia di briciole.
 */
export default function StatisticheLayout() {
  const { pathname } = useLocation();

  return (
    <>
      <Header />
      <NavSezione percorso={pathname} />
      <div className="statistiche-page">
        <div className="statistiche-container">
          <Outlet />
        </div>
      </div>
      <Footer />
    </>
  );
}
